import { render, staticRenderFns } from "./BreakTime.vue?vue&type=template&id=0b57afd2&scoped=true&"
import script from "./BreakTime.vue?vue&type=script&lang=js&"
export * from "./BreakTime.vue?vue&type=script&lang=js&"
import style0 from "./BreakTime.vue?vue&type=style&index=0&id=0b57afd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57afd2",
  null
  
)

export default component.exports